import { combineReducers } from 'redux';

import passages from './passages';
import short from './short';

import {
  PASSAGES_REQUEST,
  PASSAGES_SUCCESS,
  PASSAGES_FAILURE,
} from '../../actions/passages';

import {
  PASSAGES_SHORT_REQUEST,
  PASSAGES_SHORT_SUCCESS,
  PASSAGES_SHORT_FAILURE,
} from '../../actions/passages/short';

const defaultState = {
  loading: false,
  didInvalidate: true,  // требуется загрузка данных, не выводить заглушку 'нет данных'
};


const opts = (state = defaultState, action) => {
  switch (action.type) {
    case PASSAGES_SHORT_REQUEST:
    case PASSAGES_REQUEST: {
      return { ...state, loading: true };
    }

    case PASSAGES_SUCCESS:
    case PASSAGES_FAILURE:
    case PASSAGES_SHORT_SUCCESS:
    case PASSAGES_SHORT_FAILURE: {
      return { ...state, loading: false, didInvalidate: false };
    }

    default:
  }

  return state;
};


export default combineReducers({
  data: passages,
  short,
  opts,
});
